import axios from 'axios'
import library from '../../../utils/Library'

export const updateApplicationInstanceAppModule = async (body) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('e_authz') +
    '/updateApplicationInstanceAppModuleEAuthz'
  return await axios({
    url: URL,
    method: 'PUT',
    data: body,
    headers: { Authorization: `Bearer ${TOKEN}` }
  })
}
